// Peta nama ikon produk → glyph Material Symbols (Material Design 3, Rounded).
// Dipisah dari AppIcon.vue agar bisa dibaca kode non-komponen — mis. test
// keunikan ikon menu di src/config/internal-menu.test.ts.
//
// Setiap glyph baru WAJIB juga ditambahkan ke daftar `icon_names` di
// index.html (font di-subset; glyph di luar daftar tampil sebagai teks).

export type IconName =
  | 'menu' | 'close' | 'home' | 'newspaper' | 'calendar' | 'search' | 'user'
  | 'logout' | 'check-circle' | 'alert-triangle' | 'clock' | 'arrow-right'
  | 'chevron-right' | 'chevron-down' | 'inbox' | 'send' | 'shield' | 'sparkles'
  | 'archive' | 'download' | 'trash' | 'award'
  | 'book' | 'chip' | 'leaf' | 'anchor' | 'heart' | 'dome' | 'megaphone'
  | 'briefcase' | 'globe' | 'palette' | 'activity' | 'scale' | 'wheat' | 'bolt'
  | 'users' | 'lock' | 'eye' | 'eye-off' | 'science' | 'health'
  | 'check' | 'chevron-up'
  // Menu panel internal — satu glyph unik per menu (src/config/internal-menu.ts).
  | 'dashboard' | 'note-add' | 'kanban' | 'work' | 'how-to-reg' | 'approval' | 'tune'
  | 'diversity' | 'badge' | 'person-add' | 'contact-page' | 'mail' | 'shield-person'
  | 'account-tree' | 'manage-accounts' | 'corporate' | 'verified-user' | 'audit-log'
  // Kontrol & aksi umum
  | 'chevron-left' | 'copy' | 'plus' | 'edit' | 'table' | 'undo' | 'edit-note' | 'forum'
  // Status & aksi (Dokumen Perbaikan UI/UX PB-04, PB-12, PB-13)
  | 'more' | 'pause' | 'cancel' | 'play' | 'info' | 'arrow-left' | 'event-repeat' | 'filter-off' | 'task'
  // Agenda publik
  | 'location'
  // Dashboard Bidang Kader (v1.8.0)
  | 'bell' | 'map' | 'trending' | 'dokumen' | 'unggah' | 'tanya'

// Pemetaan ke nama glyph Material Symbols.
export const GLYPH: Record<IconName, string> = {
  menu: 'menu',
  close: 'close',
  home: 'home',
  newspaper: 'article',
  calendar: 'calendar_month',
  search: 'search',
  user: 'person',
  logout: 'logout',
  'check-circle': 'check_circle',
  'alert-triangle': 'warning',
  clock: 'schedule',
  'arrow-right': 'arrow_forward',
  'chevron-right': 'chevron_right',
  'chevron-down': 'expand_more',
  'chevron-up': 'expand_less',
  check: 'check',
  inbox: 'inbox',
  send: 'send',
  shield: 'shield_lock',
  sparkles: 'auto_awesome',
  archive: 'inventory_2',
  download: 'download',
  trash: 'delete',
  award: 'award_star',
  // Bidang gerakan
  book: 'school',
  chip: 'memory',
  leaf: 'eco',
  anchor: 'anchor',
  heart: 'volunteer_activism',
  dome: 'mosque',
  megaphone: 'campaign',
  briefcase: 'business_center',
  globe: 'public',
  palette: 'palette',
  activity: 'sports_soccer',
  scale: 'scale',
  wheat: 'nutrition',
  bolt: 'bolt',
  users: 'groups',
  lock: 'lock',
  eye: 'visibility',
  'eye-off': 'visibility_off',
  science: 'science',
  health: 'health_and_safety',
  // Menu panel internal
  dashboard: 'space_dashboard',
  'note-add': 'note_add',
  kanban: 'view_kanban',
  work: 'work',
  'how-to-reg': 'how_to_reg',
  approval: 'approval',
  tune: 'tune',
  diversity: 'diversity_3',
  badge: 'badge',
  'person-add': 'person_add',
  'contact-page': 'contact_page',
  mail: 'mail',
  'shield-person': 'shield_person',
  'account-tree': 'account_tree',
  'manage-accounts': 'manage_accounts',
  corporate: 'corporate_fare',
  'verified-user': 'verified_user',
  'audit-log': 'manage_history',
  // Kontrol & aksi umum
  'chevron-left': 'chevron_left',
  copy: 'content_copy',
  plus: 'add',
  edit: 'edit',
  table: 'table_rows',
  undo: 'undo',
  'edit-note': 'edit_note',
  forum: 'forum',
  more: 'more_vert',
  pause: 'pause_circle',
  cancel: 'cancel',
  play: 'play_circle',
  info: 'info',
  'arrow-left': 'arrow_back',
  'event-repeat': 'event_repeat',
  'filter-off': 'filter_alt_off',
  task: 'task_alt',
  location: 'location_on',
  bell: 'notifications',
  map: 'map',
  trending: 'trending_up',
  dokumen: 'description',
  unggah: 'upload_file',
  tanya: 'help',
}
